import type { KaiBookingDetailContext } from "@/services/kaiApi";

/**
 * Build the booking-detail snapshot Kai receives in
 * `client_context.booking_detail_context` when the user is on a booking detail
 * route (`/bookings/:sourceId`), or `undefined` on any other route.
 *
 * This lets Kai treat the viewed booking as the active one for bill-of-lading,
 * document, and pricing follow-ups ("who is the consignee on the BL?",
 * "download the BL") without the user ever pasting the source_id.
 */
export function buildKaiBookingDetailContext(
  pathname: string,
): KaiBookingDetailContext | undefined {
  // Match `/bookings/:sourceId` but not the list route `/bookings` or nested
  // sub-routes we do not want to treat as a single active booking.
  const match = /^\/bookings\/([^/]+)\/?$/.exec(pathname);
  if (!match) return undefined;
  const sourceId = decodeURIComponent(match[1]);
  if (!sourceId) return undefined;
  return { source_id: sourceId };
}
